import React, {useState, useEffect, useContext} from 'react';
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useFetch from '../../../../hooks/use-fetch';

import {CurrentUserContext} from "../../../../contexts/current-user";

import Spinner from '../../../../components/loader';
import Layout from '../../../../components/layout';
import ModelsTable from "./table";
import FormModel from './form';


const ModelsDirectory = (props) => {
  const { t } = useTranslation();
  let history = useHistory();
  const [currentUserState, setCurrentUserState] = useContext(CurrentUserContext);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [devicesModels, setDevicesModels] = useState([]);
  const [item, setItem] = useState('');
  const [itemId, setItemId] = useState('');


  let [isOpen, setIsOpen] = useState(false)

  const [{response, isLoading, error, meta}, doFetchTableData] = useFetch('/administration/directories/device_models', true);
  const [{response: deleteResponse, isLoading: deleteIsLoading}, doFetchDelete] = useFetch(`/administration/directories/device_models/${itemId}`, true)


  const headerData = {
    title: 'models',
    buttonsList: [
      {
        text: 'add_model',
        action: () => openModal()
      }
    ],
  };

  useEffect(() => {
    setLoading(true);
    doFetchTableData();
  }, []);

  useEffect(() => {
    if (!response) {
      return
    }
    setTableData(response.data);
    setLoading(false);
  }, [response]);

  const onItemEdit = (id) => {
    setItem(tableData.find(it => it.id === id));
    openModal();
  }

  const onItemDelete = (id) => {
    setItemId(id);
    doFetchDelete({
      method: 'DELETE'
    });
  }

  useEffect(() => {
    if(deleteIsLoading) {
      return
    }
    reloadTable()
  },[deleteIsLoading])


  function closeModal() {
    setTimeout(() => {
      setItem('');
    }, 300);
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  const reloadTable = () => {
    setLoading(true);
    doFetchTableData();
  };


  return (
    <Layout
      isWide={true}
      headerData={headerData}
    >
      {loading ? <Spinner/> : (
        <div className="mt-8 pb-10">
          <ModelsTable
            tableData={tableData}
            isLoading={isLoading}
            onItemEdit={onItemEdit}
            onItemDelete={onItemDelete}
          />
        </div>
      )}
      <FormModel closeModal={closeModal} isOpen={isOpen} item={item} reloadTable={reloadTable}/>
    </Layout>
  );
};

export default ModelsDirectory;
